module.exports = __webpack_public_path__ + "static/media/SG.0c14f708.svg";